import React, { memo } from "react";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ItemAnswer = memo(({ className, itemAnswer, onSelected }) => {
  return (
    <div className={className}>
      <div onClick={onSelected} className={"variation-tab"}>
        <div className="flex items-center justify-center">
          {itemAnswer?.["image"] && (
            <LazyLoadImage
              src={
                !itemAnswer?.isSelected
                  ? itemAnswer?.["inactive-image"]
                  : itemAnswer?.["image"]
              }
              className="rounded-md"
              style={{ width: 50, height: 50 }}
              alt="product image"
            />
          )}
        </div>
        <div
          className={
            itemAnswer.isSelected
              ? "font-700 fs-14 text-amount flex justify-center text-name mt-3"
              : "font-500 fs-14 text-amount flex justify-center text-name mt-3"
          }
        >
          {itemAnswer?.["name"]}
        </div>
      </div>
    </div>
  );
});

export default styled(ItemAnswer)`
  position: relative;
  width: 120px;
  .variation-tab {
    width: 120px;
    justify-content: center;
    display: relative;
  }
  .text-amount {
    text-align: center;
    color: #1a1a1a;
    &.active {
      color: #b98803;
    }
  }
`;
